import clsx from 'clsx';
import styles from './index.module.scss';
import { useContext, useMemo, useState } from 'react';
import { CompanyContext } from 'index';
import { ContentBox } from 'components/ContentBox';
import { CompanyLogo } from 'components/CompanyLogo';
import PhoneForm from './phone-from';
import PersonalDataForm from './personal-data-form';
import { getOrganizationAlias } from 'common/organization/utils/get-organization-alias';

export interface UnsecuredDriverLoginPageProps {
  className?: string;
}

enum DriverLoginStepEnum {
  phoneNumberForm,
  personalData,
}

function UnsecuredDriverLoginPage(props: UnsecuredDriverLoginPageProps) {
  const [currentStep, setCurrentStep] = useState<DriverLoginStepEnum>(
    DriverLoginStepEnum.phoneNumberForm
  );
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const organizationAlias = useMemo(() => {
    const organizationAlias = getOrganizationAlias();
    return organizationAlias;
  }, []);

  const onContinuePhoneForm = (phone: string) => {
    setPhoneNumber(phone);
    setCurrentStep(DriverLoginStepEnum.personalData);
  };

  const company = useContext(CompanyContext);

  return (
    <div className={clsx(styles.root, props.className)}>
      <ContentBox className={styles.content}>
        <CompanyLogo src={company.logo} responsive={true} />
        <div className={styles.description}>
          {currentStep === DriverLoginStepEnum.phoneNumberForm
            ? 'Please enter your phone number.'
            : ''}
          {currentStep === DriverLoginStepEnum.personalData
            ? 'Please enter your information.'
            : ''}
        </div>
        <div className={styles.formWrapper}>
          {currentStep === DriverLoginStepEnum.phoneNumberForm && (
            <PhoneForm onContinue={onContinuePhoneForm} />
          )}
          {currentStep === DriverLoginStepEnum.personalData && (
            <PersonalDataForm
              phoneNumber={phoneNumber}
              organizationAlias={organizationAlias}
            />
          )}
        </div>
      </ContentBox>
      <div className={styles.note}>
        {currentStep === DriverLoginStepEnum.phoneNumberForm
          ? 'You will only be contacted by a text message once your documents have been reviewed. Please note that submissions can take 24-48 hours to be reviewed.'
          : ''}
        {currentStep === DriverLoginStepEnum.personalData ? (
          <>
            {"By proceeding with this process I agree to Haul's "}
            <a href="Public/DriverLoginPage#">TOS and Privacy policy</a>
            {process.env.REACT_APP_LOCALHOST_FLEET === 'jbhunt' && (
              <>
                {" and JB Hunt's "}
                <a
                  href="https://www.jbhunt.com/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </>
            )}
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default UnsecuredDriverLoginPage;
